import setReduxAction from 'modules/redux/actions/set'
import getRequestsNetworkSelector from 'modules/training/modules/network/selectors/get-requests'
import { NETWORK_ACTION, NETWORK_PATH } from 'modules/training/modules/network/constants'

function incrementRetryCountNetworkAction (action) {
  return (dispatch, getState) => {
    const requests = getRequestsNetworkSelector()(getState())
    const request = requests.find(request => request.action === action)
    dispatch(
      setReduxAction({
        type: NETWORK_ACTION.INCREMENT_RETRY_COUNT,
        payload: {
          path: NETWORK_PATH.REQUESTS,
          value: requests.map(req => {
            if (req === request) {
              req = {
                ...req,
                retryCount: req.retryCount + 1,
                isSaving: false
              }
            }
            return req
          })
        }
      })
    )
  }
}

export default incrementRetryCountNetworkAction
